import { useEffect, useMemo, useState } from "react";
import { AnimatePresence, motion, Variants } from "framer-motion";

import { StepOne } from "./component/StepOne";
import { StepTwo } from "./component/StepTwo";
import { StepThree } from "./component/StepThree";
import { isMobile } from "../../utils/func";
import { useLocation } from "react-router-dom";
import { setDescription } from "../../seo/seo";

const ENTER_DUR = 0.85; //  오른쪽에서 들어오는 속도(느리게)
const EXIT_DUR = 0.55; //  왼쪽으로 사라지는 속도(느리게)
const FADE_DUR = 0.35; //  사라지는 페이드 길이
const FADE_DELAY = 0.1; //  너무 빨리 투명해지는 느낌 방지

const variants = {
  enter: {
    x: "100%",
    opacity: 1,
    transition: {
      type: "tween",
      duration: ENTER_DUR,
      ease: [0.22, 1, 0.36, 1],
    },
  },
  center: {
    x: "0%",
    opacity: 1,
    transition: {
      type: "tween",
      duration: ENTER_DUR,
      ease: [0.22, 1, 0.36, 1],
    },
  },
  exit: {
    x: "-25%",
    opacity: 0,
    transition: {
      x: { type: "tween", duration: EXIT_DUR, ease: [0.22, 1, 0.36, 1] },
      opacity: {
        duration: FADE_DUR,
        delay: FADE_DELAY,
        ease: [0.33, 0, 0.67, 1],
      },
    },
  },
} as const satisfies Variants;

const Application = () => {
  const { search } = useLocation();
  const [form, setForm] = useState({
    company: "",
    representative: "",
    department: "",
    email: "",
    phone: "",
  });
  const [step, setStep] = useState(1);

  const setStepWithPush = useMemo(() => {
    return (nextStep: number) => {
      setStep(nextStep);
      window.scrollTo(0, 0);
    };
  }, []);

  const Current =
    step === 1 ? (
      <StepOne form={form} setForm={setForm} setStep={setStepWithPush} />
    ) : step === 2 ? (
      <StepTwo setStep={setStepWithPush} form={form} />
    ) : step === 3 ? (
      <StepThree />
    ) : null;

  useEffect(() => {
    document.title = "품 : Poom | 도입문의";
    setDescription(
      "성장하는 비즈니스를 위한 최적의 파트너, 품(POOM). 지금 무료 상담을 통해 우리 사업장에 딱 맞는 통합 정산 솔루션을 제안받으세요.",
    );
  }, []);

  return (
    <div className="w-full flex flex-col">
      <div
        className="relative isolate w-full pt-20 pb-20 flex justify-center overflow-x-hidden"
        style={{
          backgroundImage: isMobile()
            ? "url('/assets/images/home/gradient_mobile.png')"
            : "url('/assets/images/home/gradient.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "top center",
          flex: 1,
        }}
      >
        {/*  grid 1칸에 겹쳐 올림: 스크롤 높이 유지됨 (absolute/중복렌더링 X) */}
        <div className="w-full flex justify-center px-6 pt-9">
          <div className="grid w-full place-items-start">
            <AnimatePresence initial={false} mode="wait">
              <motion.div
                key={step}
                variants={variants}
                initial="enter"
                animate="center"
                exit="exit"
                style={{ gridArea: "1 / 1" }}
                className="flex justify-center w-full"
              >
                {Current}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Application;
